import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IonicModule } from '@ionic/angular';

import { MiscModule } from '../../misc/misc.module';
import { HistpryPageRoutingModule } from './history-routing.module';
import { HistoryPageComponent } from './history.page';

@NgModule({
  declarations: [HistoryPageComponent],
  imports: [CommonModule, IonicModule, HistpryPageRoutingModule, MiscModule]
})
export class HistoryPageModule {}
